import React from 'react';
import { motion } from 'framer-motion';
import { fadeInUp, staggerContainer } from '../hooks/useScrollAnimation';
import { Cloud, Shield, Brain, Rocket } from 'lucide-react';
interface TransformationCardProps {
  title: string;
  metric: string;
  description: string;
  icon: React.ReactNode;
}
function TransformationCard({
  title,
  metric,
  description,
  icon
}: TransformationCardProps) {
  return <motion.div variants={fadeInUp} className="bg-dark-card border-y border-r border-dark-border border-l-4 border-l-gold/60 p-6 rounded-r-xl transition-colors duration-300 hover:border-l-gold group" data-id="element-403">
      <div className="flex justify-between items-start mb-4" data-id="element-404">
        <div className="p-3 bg-dark-elevated rounded-lg text-gold/80" data-id="element-405">
          {icon}
        </div>
        <span className="font-mono text-gold font-bold text-lg" data-id="element-406">{metric}</span>
      </div>
      <h3 className="text-xl font-bold text-white mb-2" data-id="element-407">{title}</h3>
      <p className="text-slate-400 text-sm leading-relaxed" data-id="element-408">{description}</p>
    </motion.div>;
}
export function TransformationSection() {
  return <section id="transformation" className="py-20 bg-dark-bg" data-id="element-409">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-410">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={staggerContainer} data-id="element-411">
          <motion.div variants={fadeInUp} className="mb-16" data-id="element-412">
            <span className="font-sans text-gold/80 tracking-widest uppercase text-xs font-semibold mb-2 block" data-id="element-413">
              Strategic Initiatives
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-white" data-id="element-414">
              Transformation Highlights
            </h2>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-415">
            <TransformationCard title="Cloud-First Migration" metric="94% Complete" description="Migrated 50,000+ VMs to hybrid cloud architecture, retiring 8 legacy data centers and reducing carbon footprint by 60%." icon={<Cloud className="w-6 h-6" data-id="element-417" />} data-id="element-416" />
            <TransformationCard title="Zero-Trust Architecture" metric="40 Countries" description="Implemented enterprise-wide zero-trust security framework, eliminating VPN dependency and reducing attack surface by 85%." icon={<Shield className="w-6 h-6" data-id="element-419" />} data-id="element-418" />
            <TransformationCard title="AI/ML Platform" metric="200+ Scientists" description="Built centralized MLOps platform enabling rapid model deployment, serving 200+ data scientists and processing 5PB of data daily." icon={<Brain className="w-6 h-6" data-id="element-421" />} data-id="element-420" />
            <TransformationCard title="DevOps Transformation" metric="300x Speed" description="Reduced deployment cycles from quarterly to daily releases through automated CI/CD pipelines and cultural transformation." icon={<Rocket className="w-6 h-6" data-id="element-423" />} data-id="element-422" />
          </div>
        </motion.div>
      </div>
    </section>;
}